import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Height {
  FT_5_0_OR_LESS = "50",
  FT_5_1 = "51",
  FT_5_2 = "52",
  FT_5_3 = "53",
  FT_5_4 = "54",
  FT_5_5 = "55",
  FT_5_6 = "56",
  FT_5_7 = "57",
  FT_5_8 = "58",
  FT_5_9 = "59",
  FT_5_10 = "60",
  FT_5_11 = "61",
  FT_6_0 = "62",
  FT_6_1 = "63",
  FT_6_2 = "64",
  FT_6_3 = "65",
  FT_6_4 = "66",
  FT_6_5_OR_MORE = "67",
}

const HEIGHT_ATTRIBUTE_VALUES: ReadonlyArray<AttributeValue> = [
  {
    id: Height.FT_5_0_OR_LESS,
    label: "5'0\" (< 152 cm)",
    iconLabel: "▁",
  },
  { id: Height.FT_5_1, label: "5'1\" (155 cm)", iconLabel: "▂" },
  { id: Height.FT_5_2, label: "5'2\" (157 cm)", iconLabel: "▃" },
  { id: Height.FT_5_3, label: "5'3\" (160 cm)", iconLabel: "▄" },
  { id: Height.FT_5_4, label: "5'4\" (163 cm)", iconLabel: "▅" },
  { id: Height.FT_5_5, label: "5'5\" (165 cm)", iconLabel: "▆" },
  { id: Height.FT_5_6, label: "5'6\" (168 cm)", iconLabel: "▇" },
  { id: Height.FT_5_7, label: "5'7\" (170 cm)", iconLabel: "█" },
  { id: Height.FT_5_8, label: "5'8\" (173 cm)", iconLabel: "█▁" },
  { id: Height.FT_5_9, label: "5'9\" (175 cm)", iconLabel: "█▂" },
  { id: Height.FT_5_10, label: "5'10\" (178 cm)", iconLabel: "█▃" },
  { id: Height.FT_5_11, label: "5'11\" (180 cm)", iconLabel: "█▄" },
  { id: Height.FT_6_0, label: "6'0\" (183 cm)", iconLabel: "█▅" },
  { id: Height.FT_6_1, label: "6'1\" (185 cm)", iconLabel: "█▆" },
  { id: Height.FT_6_2, label: "6'2\" (188 cm)", iconLabel: "█▇" },
  { id: Height.FT_6_3, label: "6'3\" (191 cm)", iconLabel: "██" },
  { id: Height.FT_6_4, label: "6'4\" (193 cm)", iconLabel: "██▁" },
  {
    id: Height.FT_6_5_OR_MORE,
    label: "6'5\" (> 196 cm)",
    iconLabel: "██▂",
  },
];

export const UserHeightAttributeSet: UserAttributeSet = {
  id: UserAttributeType.HEIGHT,
  isMultiSelect: false,
  map: attributeListToMap(HEIGHT_ATTRIBUTE_VALUES),
} as const;
